<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Coupons</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a href="#"><i class="ti ti-smart-home"></i></a>
          </li>
          <li class="breadcrumb-item">Super Admin</li>
          <li class="breadcrumb-item active" aria-current="page">Coupons</li>
        </ol>
      </nav>
    </div>
    <div class="ms-2">
      <button class="btn btn-primary d-flex align-items-center" (click)="openModal(addCouponModal)">
        <i class="ti ti-circle-plus me-2"></i>Add New Coupon
      </button>
    </div>
  </div>
  <!-- /Breadcrumb -->
  <div class="row">
    <!-- Total Coupons -->
    <div class="col-lg-3 col-md-6 d-flex d-none">
      <div class="card flex-fill">
        <div class="card-body d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center overflow-hidden">
            <div>
              <p class="fs-12 fw-medium mb-1 text-truncate">Total Coupons</p>
              <h4>{{ analytics.totalCoupons | number: '2.0-0' }}</h4>
            </div>
          </div>
          <div>
            <span class="avatar avatar-lg bg-primary flex-shrink-0">
              <i class="ti ti-box fs-16"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- /Total Coupons -->

    <!-- Active Coupons -->
    <div class="col-lg-3 col-md-6 d-flex d-none">
      <div class="card flex-fill">
        <div class="card-body d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center overflow-hidden">
            <div>
              <p class="fs-12 fw-medium mb-1 text-truncate">Active Coupons</p>
              <!-- <h4>{{ analytics.activeCoupons | number: '2.0-0' }}</h4> -->
              <h4>{{ activeCount$ | async }}</h4>
            </div>
          </div>
          <div>
            <span class="avatar avatar-lg bg-success flex-shrink-0">
              <i class="ti ti-activity-heartbeat fs-16"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- /Active Coupons -->

    <!-- Inactive Coupons -->
    <div class="col-lg-3 col-md-6 d-flex d-none">
      <div class="card flex-fill">
        <div class="card-body d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center overflow-hidden">
            <div>
              <p class="fs-12 fw-medium mb-1 text-truncate">Inactive Coupons</p>
              <!-- <h4>{{ analytics.inactiveCoupons | number: '2.0-0' }}</h4> -->
              <h4>{{ inactiveCount$ | async }}</h4>
            </div>
          </div>
          <div>
            <span class="avatar avatar-lg bg-danger flex-shrink-0">
              <i class="ti ti-player-pause fs-16"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- /Inactive Coupons -->

    <!-- No of Coupons  -->
    <div class="col-lg-3 col-md-6 d-flex d-none">
      <div class="card flex-fill">
        <div class="card-body d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center overflow-hidden">
            <div>
              <p class="fs-12 fw-medium mb-1 text-truncate">Expired Coupons</p>
              <!-- <h4>{{ analytics.noOfCouponTypes | number: '2.0-0' }}</h4> -->
              <h4>{{ expiredCount$ | async }}</h4>
            </div>
          </div>
          <div>
            <span class="avatar avatar-lg bg-skyblue flex-shrink-0">
              <i class="ti ti-mask fs-16"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- /No of Coupons -->
  </div>

  <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
      <h5>Coupon List</h5>
      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
        <!--<div class="me-3">
          <div class="input-icon-end position-relative">
            <input
              type="text"
              class="form-control date-range bookingrange"
              placeholder="dd/mm/yyyy - dd/mm/yyyy"
            />
            <span class="input-icon-addon">
              <i class="ti ti-chevron-down"></i>
            </span>
          </div>
        </div>-->
        <!-- <div class="dropdown me-3">
          <select
            class="form-select"
            id="selectedCouponType"
            [(ngModel)]="selectedCouponType"
            (ngModelChange)="onFilterChange(true)"
          >
            <option disabled selected [value]="null">Select Type</option>
            <option value="monthly">Monthly</option>
            <option value="yearly">Yearly</option>
          </select>
        </div> -->
        <div class="dropdown me-3">
          <select
            class="form-select"
            id="selectedCouponstatus"
            [(ngModel)]="selectedCouponStatus"
            (ngModelChange)="onFilterChange(true)"
          >
            <option selected [value]="null">Select Status</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
            <option value="expired">Expired</option>
          </select>
        </div>
        <div class="form-sort search-box">
          <input
            appTrimInput
            type="text"
            [(ngModel)]="search"
            (ngModelChange)="onSearchChange($event)"
            class="form-control"
            placeholder="Search Coupons"
          />
        </div>
      </div>
    </div>
    <div class="card-body p-0">
      <div class="custom-datatable-filter table-responsive">
        <table class="table datatable">
          <thead class="thead-light">
            <tr>
              <th>Coupon Name</th>
              <!-- <th>Coupon Type</th> -->
              <th>Code</th>
              <th>Used</th>
              <!-- <th>Total Subscribers</th> -->
              <th>Created Date</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="coupons$ | async as coupons">
              <tr *ngFor="let coupon of coupons">
                <td>
                  <h6 class="fw-medium">
                    <a href="javascript:void(0)">{{ coupon.name }}</a>
                  </h6>
                </td>
                <!-- <td>{{ coupon.discountType | capitalize }}</td> -->
                <td>{{ coupon.code }}</td>
                <td>{{ coupon.usedCount }}</td>
                <!-- <td>{{ coupon.totalSubscribers }}</td> -->
                <td>{{ coupon.createdAt | date: 'mediumDate' }}</td>
                <td>
                  <ng-container *ngIf="coupon.status === 'active'; else inactive">
                    <span class="badge badge-success d-inline-flex align-items-center badge-sm">
                      <!-- -->
                      Active
                    </span>
                  </ng-container>
                  <ng-template #inactive>
                    <span class="badge badge-danger d-inline-flex align-items-center badge-sm">
                      <!-- -->
                      {{ coupon.status | capitalize }}
                    </span>
                  </ng-template>
                </td>
                <td>
                  <div class="action-icon d-inline-flex">
                    <a
                      href="javascript:void(0);"
                      class="me-2"
                      (click)="openEditModal(coupon, addCouponModal)"
                      ><i class="ti ti-edit"></i
                    ></a>
                    <a href="javascript:void(0);" (click)="openDeleteModal(coupon, deleteModal)"
                      ><i class="ti ti-trash"></i
                    ></a>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>

    <!-- pagination -->
    <ng-container *ngIf="coupons$ | async as coupons">
      <ng-container *ngIf="coupons.length > 0">
        <div class="d-flex align-items-center justify-content-between ms-2">
          <div>
            Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ pageLastRecord }} of
            {{ totalCount }} entries
          </div>
          <div class="has-text-centered mt-3">
            <app-pagination
              [currentPage]="currentPage"
              [pageSize]="pageLimit"
              [totalRows]="totalCount"
              (pageChange)="onPageChange($event)"
            ></app-pagination>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <!-- pagination end -->
  </div>
</div>

<!-- Add Coupon -->
<ng-template #addCouponModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ operation }} Coupon</h4>
    <button
      type="button"
      class="btn-close custom-btn-close"
      aria-label="Close"
      (click)="closeModal()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <form [formGroup]="form">
    <div class="modal-body pb-0">
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label"> Coupon Code <span class="text-danger">*</span> </label>
            <input
              type="text"
              class="form-control text-uppercase"
              formControlName="code"
              appTrimInput
              (input)="onCouponCodeInput()"
            />
            @if (getErrorMessage('code')) {
              <div class="text-danger mt-1">
                {{ getErrorMessage('code') }}
              </div>
            }
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label"> Coupon Name <span class="text-danger">*</span> </label>
            <input type="text" class="form-control" formControlName="name" appTrimInput />
            @if (getErrorMessage('name')) {
              <div class="text-danger mt-1">
                {{ getErrorMessage('name') }}
              </div>
            }
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label"> Discount Type <span class="text-danger">*</span> </label>
            <select class="form-select" formControlName="discountType">
              <option value="percentage">Percentage</option>
              <option value="fixed">Fixed</option>
            </select>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label"> Discount Value <span class="text-danger">*</span> </label>
            <input type="number" class="form-control" formControlName="discountValue" />
            @if (getErrorMessage('discountValue')) {
              <div class="text-danger mt-1">
                {{ getErrorMessage('discountValue') }}
              </div>
            }
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label">Maximum Discount</label>
            <input type="number" class="form-control" formControlName="maxDiscount" />
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label"> Minimum Order <span class="text-danger">*</span> </label>
            <input type="number" class="form-control" formControlName="minimumOrder" />
            @if (getErrorMessage('minimumOrder')) {
              <div class="text-danger mt-1">
                {{ getErrorMessage('minimumOrder') }}
              </div>
            }
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label">Usage Limit</label>
            <input type="number" class="form-control" formControlName="usageLimit" />
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label">
              Usage Limit Per User <span class="text-danger">*</span>
            </label>
            <input type="number" class="form-control" formControlName="usageLimitPerUser" />
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label"> Start Date <span class="text-danger">*</span> </label>
            <input type="date" class="form-control" formControlName="startDate" />
            @if (getErrorMessage('startDate')) {
              <div class="text-danger mt-1">
                {{ getErrorMessage('startDate') }}
              </div>
            }
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label"> Expiry Date <span class="text-danger">*</span> </label>
            <input type="date" class="form-control" formControlName="expiryDate" />
            @if (getErrorMessage('expiryDate')) {
              <div class="text-danger mt-1">
                {{ getErrorMessage('expiryDate') }}
              </div>
            }
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label">Status</label>
            <select class="form-select" formControlName="status">
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
        </div>

        <div class="col-md-6 d-flex align-items-center">
          <div class="form-check mt-4">
            <input
              class="form-check-input"
              type="checkbox"
              id="isFirstOrderOnly"
              formControlName="isFirstOrderOnly"
            />
            <label class="form-check-label" for="isFirstOrderOnly"> First Order Only </label>
          </div>
        </div>

        <div class="col-12">
          <div class="mb-3">
            <label class="form-label">Description</label>
            <textarea class="form-control" rows="3" formControlName="description"></textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="form.invalid"
        (click)="upsertCoupon()"
      >
        {{ operation === 'Add' ? 'Add Coupon' : 'Save Changes' }}
      </button>
    </div>
  </form>
  @if (getFormError()) {
    <div class="alert alert-danger mt-3">
      {{ getFormError() }}
    </div>
  }
</ng-template>
<!-- /Add Coupon -->

<!-- Delete Modal -->
<ng-template #deleteModal let-modal>
  <div class="modal-body text-center">
    <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
      <i class="ti ti-trash-x fs-36"></i>
    </span>
    <h4 class="mb-1">Confirm Delete</h4>
    <p class="mb-3">Ar you sure you want to delete the Coupon?</p>
    <div class="d-flex justify-content-center">
      <a href="javascript:void(0);" class="btn btn-light me-3" (click)="closeModal()">Cancel</a>
      <a href="javascript:void(0);" class="btn btn-danger" (click)="confirmDelete()">Yes, Delete</a>
    </div>
  </div>
</ng-template>
<!-- /Delete Modal -->
